import "@/App.css";
import Site from "./components/site/Site";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <Site />
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
